module.exports = __webpack_public_path__ + "img/small-7.3c93f6f0.webp";